'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/lib/integrations/supabase';


export default function RootPage() {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      router.replace('/home');
    } else {
      router.replace('/login');
    }
  }, [isAuthenticated, isLoading, router]);

  // Show branded loading while checking auth
  return (
    <div className="w-full h-full min-h-screen bg-background p-4 flex flex-col gap-4">
      <div className="w-full h-16 bg-muted/20 animate-pulse rounded-xl" />
      <div className="flex-1 w-full bg-muted/10 animate-pulse rounded-xl" />
    </div>
  );
}
